import {Component, OnInit} from '@angular/core';
import { BroadcastService } from '@cv-invision/core';

@Component({
	selector: 'cv-intelligence-component',
	template: `
        <router-outlet></router-outlet>
	`
})
export class IntelligenceComponent implements OnInit {
	constructor(private broadcastService: BroadcastService) {
		// silence is golden
	}

	ngOnInit(): void {
		this.broadcastService.broadcast({
			name: 'CHATBOT',
			event: {}
		});
	}
}
